export function asString(value: unknown): string | null {
  return typeof value === 'string' && value.length > 0 ? value : null;
}

export function asTrimmedString(value: unknown): string | null {
  return typeof value === 'string' ? asString(value.trim()) : null;
}

export function asNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

export function asBoolean(value: unknown, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

export function asStringArray(value: unknown): ReadonlyArray<string> {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.filter((item): item is string => typeof item === 'string');
}

export function asStringSet(value: unknown): ReadonlySet<string> {
  return new Set<string>(asStringArray(value));
}

export function asStringMap(value: unknown): ReadonlyMap<string, string> {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return new Map<string, string>();
  }

  const entries = Object.entries(value as Record<string, unknown>).filter(
    (entry): entry is [string, string] => typeof entry[1] === 'string'
  );

  return new Map<string, string>(entries);
}

const SIX_DIGIT_HEX = /^#[0-9a-f]{6}$/i;

export function asHexColor(value: unknown): string | null {
  const text = asString(value)?.trim() ?? null;
  return text !== null && SIX_DIGIT_HEX.test(text) ? text.toLowerCase() : null;
}

function isRecord(value: unknown): value is Readonly<Record<string, unknown>> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function asRecord(
  value: unknown
): Readonly<Record<string, unknown>> | null {
  return isRecord(value) ? value : null;
}

export function parseJsonOrNull(raw: string): unknown {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
